import React, { Dispatch, SetStateAction, useState } from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { ProviderInvoiceDA } from '../../services/admin/provider.invoice.service';
import { GlobalSwal } from '../../styles/swal.style';
import { Company } from '../../models/company.model';
import { Error } from '../../models/error.model';
import { ProviderInvoice } from '../../models/provider.invoice.model';
import { modalHide } from '../../utils/modal.util';
import { getError } from '../../languages/translations/response';
import { normalizeStatus } from '../../libraries/status.document.library';
import { errorWebHandler } from '../../scripts/error.web.handler.script';

import AppLoading from '../Loading';

export interface AppModalProviderInvoiceUpdateInvalidateProps {
  companyForUser: Company | null
  providerInvoice: ProviderInvoice | null,
  setProviderInvoice: Dispatch<SetStateAction<ProviderInvoice | null>>
};

let errorResponse: Error, providerInvoiceResponse: ProviderInvoice;

const AppModalProviderInvoiceUpdateInvalidate: React.FunctionComponent<AppModalProviderInvoiceUpdateInvalidateProps> = ({companyForUser, providerInvoice, setProviderInvoice}) => {
  const {lang} = StateLanguage()

  const [loadIndicator, setLoadIndicator] = useState('off')

  const submitProviderInvoiceInvalidate = async () => {
    setLoadIndicator('on')

    if (companyForUser && providerInvoice) {
      await ProviderInvoiceDA.putProviderInvoiceStatus(companyForUser.id, providerInvoice.id, null, null, null, null).then( (response) => {
        if (response.status === 200) {
          providerInvoiceResponse = response.data
          providerInvoiceResponse.status = normalizeStatus(providerInvoiceResponse.status)
          if (providerInvoiceResponse.payment_status) providerInvoiceResponse.payment_status = normalizeStatus(providerInvoiceResponse.payment_status)
          setProviderInvoice(providerInvoiceResponse)

          GlobalSwal.fire({
            title: lang.labels.successfullyUpdatedStatus,
            text: lang.labels.actionCompletedReturningToPage,
            icon: 'success',
            showConfirmButton: false,
            timer: 2200
          }).then( () => {
            executeHideModalProviderInvoiceUpdateInvalidate()
          })
        } else {
          errorResponse = response.data

          GlobalSwal.fire({
            title: getError(errorResponse.code, lang.code, errorResponse.message),
            text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
            icon: 'error',
            showConfirmButton: false,
            timer: 2200
          })
        }
      }).catch( (error) => {
        errorWebHandler(lang, error)
      }).finally(() => {
        setLoadIndicator('off')
      })
    }
  }

  const executeHideModalProviderInvoiceUpdateInvalidate = () => {
    modalHide('modal-provider-invoice-update-invalidate')
  }

  return (
    <div id="modal-provider-invoice-update-invalidate" className="modal fade" tabIndex={-1} aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="text-capitalize">{lang.labels.invalidateProviderInvoice}</h2>
          </div>
          <div className="modal-body">
            { providerInvoice
              ?
              <div className="text-justify fw-semibold">
                {lang.labels.ifYouInvalidateProvaiderInvoice}
                <strong className=" ms-1">{providerInvoice.provider_invoice_number}</strong>
                {lang.labels.theAssociatedAccountingEntriesWillBeDeletedProviderInvoice}
                <br /><br />
                {lang.labels.toPerformAnySubsequentActionWithProviderInvoice}
              </div>
              :
              <AppLoading></AppLoading>
            }
          </div>
          <div className="modal-footer flex-center">
            <button className="btn btn-secondary mx-2" type="reset" onClick={executeHideModalProviderInvoiceUpdateInvalidate}>{lang.labels.noCancel}</button>
            <button className="btn btn-primary mx-2" type="button" data-kt-indicator={loadIndicator} onClick={submitProviderInvoiceInvalidate}>
              <span className="indicator-label">{lang.labels.yesInvalidate}</span>
              <span className="indicator-progress">
                {lang.labels.pleaseWait}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
};

export default AppModalProviderInvoiceUpdateInvalidate;
